import Constants from '@helpers/Constants';

export type RuntimeConfigValue = string | boolean | number | undefined;
export type RuntimeConfigEnvironment = {
  JSE2E?: RuntimeConfigValue;
};

export type RuntimeConfigShape = {
  isE2E: boolean;
  disablePasswordAutofill: boolean;
  disableCreatePlanPrompt: boolean;
};

export function parseRuntimeConfigBoolean(value: RuntimeConfigValue) {
  return value === true || value === 'true' || value === '1' || value === 1;
}

export function createRuntimeConfig(
  environment: RuntimeConfigEnvironment = {}
): RuntimeConfigShape {
  const isE2E = parseRuntimeConfigBoolean(environment.JSE2E);

  return {
    isE2E,
    disablePasswordAutofill: isE2E,
    disableCreatePlanPrompt: isE2E,
  };
}

function readRuntimeEnvironment(): RuntimeConfigEnvironment {
  return {
    JSE2E: Constants.joinstar.JSE2E,
  };
}

export const RuntimeConfig = createRuntimeConfig(readRuntimeEnvironment());
